import DataTile from "./DataTile";
import {fetchTargets} from "../../../actions";
import React from "react";
import {bbTranslateRiskToColor} from "../../../util/bbHelpers";
import {useSelector} from "react-redux";
import RiskRibbon from "../../risk/RiskRibbon";
import BBIconComputerAttentionVulnerability from "../../../assets/bbCustomIcons/BBIconComputerAttentionVulnerability";

const Tile = (props) => {

    const {customerId} = props;

    /**************************/
    /*Setup State and Dispatch*/
    /**************************/
    const {customerInView} = useSelector(({customer}) => customer);

    const customerIdToUse = customerId ? customerId : customerInView;

    const valueFunction = (stateData) => stateData ? stateData[customerIdToUse] ? stateData[customerIdToUse].targets_with_vulns : null : null;

    const translateValueToRisk = (value) => {
        if (typeof value !== "number") {
            return null
        } else if (value <= 0) {
            return 0
        } else if (value <= 2) {
            return 1
        } else if (value <= 3) {
            return 2
        } else if (value <= 5) {
            return 3
        } else {
            return 4
        }
    }

    const colorFunction = (stateData) => {
        const num = valueFunction(stateData);
        return bbTranslateRiskToColor(translateValueToRisk(num));
    }

    const riskRibbon = (stateData) => {
        const num = translateValueToRisk(valueFunction(stateData));
        return num
            ? <RiskRibbon ratingBy5={num} />
            : null;
    }

    return (
        <DataTile
            colorBgFunction={colorFunction}
            subTitle= "Vulnerable Targets"
            tipText={"The number of hosts that contain one or more NIST Common Vulnerabilities and Exposures (CVEs).  CVEs provide attack vector opportunities for attackers."}
            icon={<BBIconComputerAttentionVulnerability style={{fontSize: "70px"}}/>}
            stateName="customer"
            // useDeepDataStore
            // deepDataStore = {(dataStore) => dataStore? dataStore[customerIdToUse] ? dataStore[customerIdToUse].targets : null : null}
            stateElement="metaTargets"
            stateLoaderName="loadingTargets"
            stateLoaderError="loadingTargetsError"
            stateFetchAction={fetchTargets(
                {
                    customerId: customerIdToUse
                }
            )}
            preventDataFetchConditionFunction={(dataStore) => !customerIdToUse}
            valueFunction={valueFunction}
            ribbonFunction={riskRibbon}
            requiresModule={"monitor"}
        />
    )

}

export default Tile;